<div class="bb-action-status">
  @if (isLoading()) {
    <bb-loading-indicator-ui loaderSize="sm"></bb-loading-indicator-ui>
  }
  @if (!isLoading() && state) {
    <bb-icon-ui size="md" [name]="state" [color]="getColor()"></bb-icon-ui>
  }
</div>
